/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./facet.defs.js";
export { main as default } from "./facet.defs.js";
